import { useEffect, useState } from 'react';
import { debounce } from 'lodash-es';

const useCarouselCardPosition = (selector: string): { windowWidth: number; cardWidth: number; resizing: boolean; } => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);
  /*
    Resizing gets passed to the carousel container so we can disable the transition
    duration while the page resizes. This will help limit the movement of the cards
    repositioning as the window width changes.
  */
  const [resizing, setResizing] = useState(false);
  useEffect(() => {
    let isResizingTimer: ReturnType<typeof setTimeout>;
    const handleResize = () => {
      debounce(() => {
        // update card and window values
        setWindowWidth(window.innerWidth);
        const card = document.querySelector<HTMLElement>(selector);
        setCardWidth(card?.offsetWidth || 0);

        // reset resizing
        setResizing(true);
        clearTimeout(isResizingTimer);
        isResizingTimer = setTimeout(() => {
          setResizing(false);
        }, 100);
      }, 10)();
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [selector]);

  return { windowWidth, cardWidth, resizing };
};

export default useCarouselCardPosition;
